"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const rich_textarea_1 = require("rich-textarea");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const IC_X_1 = __importDefault(require("../../../assets/icons/IC_X"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const ModalConfirm_1 = __importDefault(require("../../../components/modal/ModalConfirm"));
const Status_1 = require("../../../components/status/Status");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Home_1 = __importDefault(require("../../../networking/apis/Home"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const ImagePickers_1 = __importDefault(require("../components/ImagePickers"));
const QuoteTweet_1 = __importDefault(require("../components/QuoteTweet"));
const styles_1 = __importDefault(require("../styles"));
function isUnique(arr) {
    var seen = {};
    for (var i = 0; i < arr.length; i++) {
        if (seen[arr[i]]) {
            return false;
        }
        seen[arr[i]] = true;
    }
    return true;
}
const InputView = (props) => {
    const [text, setText] = (0, react_1.useState)('');
    const textLines = text?.replace(/\n/g, '\n').split('\n');
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (props?.valueDefaul) {
            setText(props?.valueDefaul);
        }
    }, [props?.valueDefaul]);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => {
            if (inputRef.current) {
                inputRef.current?.focus();
                clearTimeout(timeout);
            }
        }, 500);
    }, []);
    const renderer = (0, rich_textarea_1.createRegexRenderer)([[constants_1.REGEX_HASHTAG, { color: '#007AFF' }]]);
    (0, react_1.useEffect)(() => {
        if (text?.length > 2000) {
            let textCut = text?.slice(0, 1999);
            setText(textCut);
            props?.onChangeContent(textCut);
        }
    }, [text]);
    (0, react_1.useEffect)(() => {
        if (props?.countHashTag > 30) {
            let textCut = text?.slice(0, text?.length - 1);
            setText(textCut);
            props?.onChangeContent(textCut);
        }
    }, [props?.countHashTag]);
    return react_native_1.Platform.OS === 'web' ? (react_1.default.createElement(react_native_1.View, { style: { width: '100%', marginTop: (0, scale_1.scale)(12), paddingRight: (0, scale_1.scale)(16) } },
        react_1.default.createElement(rich_textarea_1.RichTextarea, { ref: inputRef, value: text, style: {
                width: (0, scale_1.scale)(289),
                display: 'flex',
                fontSize: (0, scale_1.moderateScale)(15),
                color: '#292A33',
                outlineWidth: 0,
                fontFamily: 'Hiragino Kaku Gothic Pro W3',
                borderWidth: 0,
                resize: 'none',
            }, placeholder: "\u6C17\u306B\u306A\u3063\u305F\u3053\u3068\u3092\u3064\u3076\u3084\u304D\u307E\u3057\u3087\u3046", onChange: (e) => {
                props?.onChangeContent(e.target.value), setText(e.target.value);
            }, autoHeight: true, maxLength: 2000 }, renderer))) : (react_1.default.createElement(react_native_1.TextInput, { style: styles_1.default.inputText, placeholder: "\u6C17\u306B\u306A\u3063\u305F\u3053\u3068\u3092\u3064\u3076\u3084\u304D\u307E\u3057\u3087\u3046", textAlignVertical: 'center', multiline: true, onChangeText: setText, placeholderTextColor: '#C8C8C8', maxLength: 2000, autoFocus: true }, textLines.map((line, index) => {
        const breakLine = index < textLines.length - 1 ? '\n' : '';
        const words = line.split(' ');
        return (react_1.default.createElement(CustomText_1.default, { key: index, style: styles_1.default.inputTextContent },
            words.map((word, idx) => {
                const space = idx < words.length - 1 ? ' ' : '';
                if (word.match(constants_1.REGEX_HASHTAG)) {
                    return (react_1.default.createElement(CustomText_1.default, { key: `${index}${idx}`, style: [styles_1.default.inputTextContent, { color: '#007AFF' }] },
                        word,
                        space));
                }
                return (react_1.default.createElement(CustomText_1.default, { key: `${index}${idx}`, style: styles_1.default.inputTextContent },
                    word,
                    space));
            }),
            breakLine));
    })));
};
const CreatePostScreen = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { data, type, } = props?.route?.params;
    const dataUser = (0, react_redux_1.useSelector)((state) => state?.loginReducer?.dataProfile, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const idPostTweets = () => {
        const pathParam = `tweets/${decodeURIComponent(data || '')}`;
        if (pathParam?.includes('replies')) {
            let containsReplies = pathParam?.indexOf('replies') != -1;
            let textAfterSlash = '';
            let textpath = null;
            if (containsReplies) {
                textpath = pathParam?.slice(0, pathParam?.lastIndexOf('replies') + 7);
                textAfterSlash = pathParam?.slice(pathParam?.lastIndexOf('replies') + 8);
            }
            return textAfterSlash;
        }
        return data || '';
    };
    const firestorePath = () => {
        const pathParam = `tweets/${decodeURIComponent(data || '')}`;
        if (pathParam?.includes('replies')) {
            let containsReplies = pathParam?.indexOf('replies') != -1;
            let textAfterSlash = null;
            let textpath = null;
            if (containsReplies) {
                textpath = pathParam?.slice(0, pathParam?.lastIndexOf('replies') + 7);
                textAfterSlash = pathParam?.slice(pathParam?.lastIndexOf('replies') + 8);
            }
            return textpath;
        }
        return 'tweets';
    };
    const [image, setImage] = (0, react_1.useState)([]);
    const [visibleConfirm, setVisibleConfirm] = (0, react_1.useState)(false);
    const [formDataImage, setFormDataImage] = (0, react_1.useState)([]);
    const [contentTweet, setContentTweet] = (0, react_1.useState)('');
    const [countHashTag, setCountHashTag] = (0, react_1.useState)(0);
    const [statusTweet, setStatusTweet] = (0, react_1.useState)(0);
    const [dataQuote, setDataQuote] = (0, react_1.useState)();
    const [dataEdit, setDataEdit] = (0, react_1.useState)();
    const [listIdImageEdit, setListIdImageEdit] = (0, react_1.useState)([]);
    const [valueDefaul, setValueDefaul] = (0, react_1.useState)();
    const [listDeleteImage, setListDeleteImage] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [heightImage, setHeightImage] = (0, react_1.useState)((0, scale_1.scale)(135));
    const [weightImage, setWeightImage] = (0, react_1.useState)((0, scale_1.scale)(135));
    (0, react_1.useEffect)(() => {
        if (data && data != null) {
            if (react_native_1.Platform.OS === 'web') {
                const { firebase } = require('../../../../web/firebase/config');
                firebase
                    .firestore()
                    .collection(firestorePath() || 'tweets')
                    .doc(idPostTweets())
                    .get()
                    .then((res) => {
                    if (type == 'POST') {
                        setDataQuote(res.data());
                    }
                    else if (type == 'EDIT') {
                        setDataEdit(res.data());
                    }
                    setIsLoading(false);
                })
                    .catch((_err) => { });
            }
        }
        setIsLoading(false);
    }, []);
    (0, react_1.useEffect)(() => {
        if (dataEdit) {
            const imageEdit = [];
            const idImageEdit = [];
            if (dataEdit?.images && dataEdit?.images.length > 0) {
                dataEdit?.images?.map((item) => {
                    imageEdit?.push(item?.url);
                    idImageEdit?.push(item?.id);
                });
            }
            setStatusTweet(dataEdit?.publicationRange);
            setValueDefaul(dataEdit?.content);
            setContentTweet(dataEdit?.content);
            setImage(imageEdit);
            setListIdImageEdit(idImageEdit);
        }
    }, [dataEdit]);
    const selectImage = (data) => {
        let listData = [...image];
        data?.map((item) => {
            listData.push(item);
        });
        setImage(listData);
    };
    const formListImage = (data) => {
        let listData = [...formDataImage];
        data?.map((item) => {
            listData.push(item);
        });
        setFormDataImage(listData);
    };
    const addPost = async () => {
        if (!!contentTweet) {
            const array = contentTweet.match(constants_1.REGEX_HASHTAG)?.map(it => it.trim());
            if (array && !isUnique(array)) {
                dispatch(slice_1.default.actions.setToastType(false));
                dispatch(slice_1.default.actions.showToast('同じハッシュタグを入力できません'));
                return;
            }
            else if (JSON.stringify(contentTweet)?.length > 2000) {
                dispatch(slice_1.default.actions.setToastType(false));
                dispatch(slice_1.default.actions.showToast('タイムラインは約2000文字以内で入力してください。'));
                return;
            }
        }
        let typeTweet = data && data != 'null';
        const dataTweet = new FormData();
        dataTweet.append('content', contentTweet);
        if (formDataImage.length > 0) {
            for (let i = 0; i < formDataImage.length; i++) {
                dataTweet.append(' image[' + i + '][image]', formDataImage[i]);
                dataTweet.append(' image[' + i + '][display_order]', `${i + 1}`);
            }
        }
        dataTweet.append('type', `${typeTweet ? 3 : 1}`);
        dataTweet.append('publication_range', `${statusTweet}`);
        dataTweet.append('is_reply', '0');
        if (typeTweet) {
            dataTweet.append('quote_tweet_id', `${idPostTweets()}`);
        }
        setIsLoading(true);
        await Home_1.default.tweetPostApi(dataTweet)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast(typeTweet ? '引用投稿しました' : '投稿しました'));
            (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            setIsLoading(false);
        });
    };
    const editPost = async () => {
        let typeTweet = data && data != 'null';
        const dataTweet = new FormData();
        dataTweet.append('content', contentTweet);
        if (formDataImage.length > 0) {
            for (let i = 0; i < formDataImage.length; i++) {
                dataTweet.append(' image[' + i + '][image]', formDataImage[i]);
                dataTweet.append(' image[' + i + '][display_order]', `${i + 1}`);
            }
        }
        if (listDeleteImage.length > 0) {
            for (let i = 0; i < listDeleteImage.length; i++) {
                dataTweet.append(' deleting_image_ids[' + i + ']', listDeleteImage[i]);
            }
        }
        dataTweet.append('type', `${dataEdit?.type}`);
        dataTweet.append('publication_range', `${statusTweet}`);
        if (dataEdit?.type == 3) {
            dataTweet.append('quote_tweet_id', `${data}`);
        }
        dataTweet.append('is_reply', '0');
        // navigate(Routes.HOME, {
        // });
        setIsLoading(true);
        await Home_1.default.tweetEditApi(data, dataTweet)
            .then((_res) => {
            setIsLoading(false);
            dispatch(slice_1.default.actions.showToast('編集しました'));
            (0, rootNavigation_1.goBack)();
        })
            .catch((err) => {
            setIsLoading(false);
            console.log(err);
        });
    };
    (0, react_1.useEffect)(() => {
        const hashtags = contentTweet.match(constants_1.REGEX_HASHTAG);
        // Nếu không có hashtag nào được tìm thấy, trả về 0
        if (!hashtags) {
            setCountHashTag(0);
        }
        else {
            setCountHashTag(hashtags.length);
        }
        // Trả về số lượng hashtag được tìm thấy
    }, [contentTweet]);
    const deleteImage = (data) => {
        const dataDeleteImage = [...image];
        const dataFormDataImage = [...formDataImage];
        let list = [...listDeleteImage];
        let listIdImage = [...listIdImageEdit];
        if (type == 'EDIT') {
            const countImageEdit = dataDeleteImage?.length - dataFormDataImage?.length;
            dataDeleteImage.splice(data, 1);
            if (data <= countImageEdit - 1) {
                list.push(listIdImageEdit[data]);
                setListDeleteImage(list);
                listIdImage.splice(data, 1);
                setListIdImageEdit(listIdImage);
            }
            else {
                dataFormDataImage.splice(data + countImageEdit, 1);
            }
        }
        if (type == 'POST') {
            dataDeleteImage.splice(data, 1);
            dataFormDataImage.splice(data, 1);
        }
        setImage(dataDeleteImage);
        setFormDataImage(dataFormDataImage);
    };
    const checkContent = () => {
        if (contentTweet) {
            return true;
        }
        return false;
    };
    const showImage = (image) => {
        if (image?.length == 1) {
            react_native_1.Image.getSize(image[0], (width, height) => {
                if (width < (0, scale_1.scale)(290) && width > (0, scale_1.scale)(135)) {
                    setWeightImage(width);
                    setHeightImage(height);
                }
                else if (width > (0, scale_1.scale)(290)) {
                    setWeightImage(290);
                    setHeightImage(290 * (height / width));
                }
            });
            return (react_1.default.createElement(react_native_1.View, { style: {
                    width: weightImage,
                    height: heightImage,
                    flexDirection: 'row'
                } },
                react_1.default.createElement(react_native_1.Image, { source: { uri: image[0] }, style: {
                        width: '100%',
                        height: '100%',
                        borderRadius: (0, scale_1.scale)(8),
                        resizeMode: 'contain',
                    } }),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        height: (0, scale_1.scale)(30),
                        width: (0, scale_1.scale)(30),
                        top: (0, scale_1.scale)(4),
                        left: (0, scale_1.scale)(-34),
                        backgroundColor: '#000000B2',
                        borderRadius: 99,
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, onPress: () => deleteImage(0) },
                    react_1.default.createElement(IC_X_1.default, { height: (0, scale_1.scale)(20), color: '#FEFEFE' }))));
        }
        else if (image?.length > 0) {
            return (react_1.default.createElement(react_native_1.View, { style: { flex: 1 } },
                react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, style: {
                        flexDirection: 'column',
                        flexWrap: 'wrap',
                        paddingRight: (0, scale_1.scale)(46),
                        paddingLeft: (0, scale_1.scale)(3)
                    }, showsHorizontalScrollIndicator: scale_1.isPC }, image?.map?.((item, index) => {
                    return (react_1.default.createElement(react_native_1.View, { style: {
                            width: (0, scale_1.scale)(135),
                            height: (0, scale_1.scale)(135),
                            flexDirection: 'row',
                            marginRight: (0, scale_1.scale)(8),
                        }, key: index },
                        react_1.default.createElement(react_native_1.Image, { source: { uri: item }, style: {
                                width: (0, scale_1.scale)(135),
                                height: (0, scale_1.scale)(135),
                                borderRadius: (0, scale_1.scale)(8),
                            } }),
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                                height: (0, scale_1.scale)(30),
                                width: (0, scale_1.scale)(30),
                                top: (0, scale_1.scale)(4),
                                left: (0, scale_1.scale)(-34),
                                backgroundColor: '#000000B2',
                                borderRadius: 99,
                                justifyContent: 'center',
                                alignItems: 'center',
                            }, onPress: () => deleteImage(index) },
                            react_1.default.createElement(IC_X_1.default, { height: (0, scale_1.scale)(20), color: '#FEFEFE' }))));
                }))));
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            justifyContent: 'space-between',
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                }, title: 'タイムライン投稿', styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        fontWeight: '300',
                        color: '#007AFF',
                    } }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                    if (contentTweet?.length > 0 || formDataImage?.length > 0) {
                        setVisibleConfirm(true);
                    }
                    else {
                        (0, rootNavigation_1.goBack)();
                    }
                }, rightIcon: react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        fontWeight: '300',
                        color: checkContent()
                            ? 'rgba(0, 122, 255, 1)'
                            : 'rgba(0, 122, 255, 0.7)',
                    } }, "\u6295\u7A3F"), onRightPress: checkContent() ? (type == 'POST' ? addPost : editPost) : undefined }),
            react_1.default.createElement(react_native_1.View, { style: {
                    paddingLeft: (0, scale_1.scale)(16),
                    flex: 1,
                } },
                react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false, contentContainerStyle: { paddingTop: (0, scale_1.scale)(24) } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            flexDirection: 'row',
                            marginBottom: (0, scale_1.scale)(12),
                        } },
                        react_1.default.createElement(react_native_1.Image, { source: dataUser?.thumbnail_url
                                ? { uri: dataUser?.thumbnail_url }
                                : images_1.images.AvatarDefaul, style: {
                                height: (0, scale_1.scale)(42),
                                width: (0, scale_1.scale)(42),
                                marginRight: (0, scale_1.scale)(12),
                                borderRadius: 99,
                            } }),
                        react_1.default.createElement(react_native_1.View, { style: { width: '100%' } },
                            react_1.default.createElement(Status_1.Status, { statusPost: statusTweet, edit: true, onChange: (data) => setStatusTweet(data) }),
                            react_1.default.createElement(InputView, { onChangeContent: (data) => {
                                    setContentTweet(data);
                                }, valueDefaul: valueDefaul, countHashTag: countHashTag }),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(11),
                                    color: '#7C7C7C',
                                    lineHeight: (0, scale_1.moderateScale)(19),
                                    marginTop: (0, scale_1.scale)(8),
                                    marginBottom: (0, scale_1.scale)(10),
                                    paddingRight: (0, scale_1.scale)(16),
                                    ...react_native_1.Platform.select({
                                        web: {
                                            cursor: 'default',
                                        }
                                    }),
                                } }, `ハッシュタグ${countHashTag}/30`),
                            image && image?.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                showImage(image),
                                react_1.default.createElement(CustomText_1.default, { style: {
                                        fontSize: (0, scale_1.moderateScale)(11),
                                        color: '#7C7C7C',
                                        lineHeight: (0, scale_1.moderateScale)(19),
                                        marginTop: (0, scale_1.scale)(8),
                                        marginBottom: (0, scale_1.scale)(12),
                                        paddingRight: (0, scale_1.scale)(16),
                                    } },
                                    image?.length,
                                    "\u679A/30\u679A\u4E2D"))),
                            data && data != 'null' && dataQuote && type == 'POST' && (react_1.default.createElement(react_native_1.View, { style: {
                                    backgroundColor: 'white',
                                    marginRight: (0, scale_1.scale)(16),
                                    width: (0, scale_1.scale)(290),
                                    borderRadius: (0, scale_1.scale)(5),
                                } },
                                react_1.default.createElement(QuoteTweet_1.default, { data: dataQuote })))))))),
        react_1.default.createElement(react_native_1.View, { style: {
                height: (0, scale_1.scale)(64),
                width: '100%',
                backgroundColor: 'white',
                paddingHorizontal: (0, scale_1.scale)(17),
                paddingTop: (0, scale_1.scale)(17),
            } },
            react_1.default.createElement(ImagePickers_1.default, { onSelect: (data) => selectImage(data), formDataImage: (data) => formListImage(data) })),
        react_1.default.createElement(ModalConfirm_1.default, { visible: visibleConfirm, onClose: () => setVisibleConfirm(false), title: "\u6295\u7A3F\u3092\u53D6\u308A\u6D88\u3057\u307E\u3059\u304B\uFF1F", content: "\u3053\u308C\u307E\u3067\u306B\u5165\u529B\u3057\u305F\u5185\u5BB9\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002", onConfirm: () => (0, rootNavigation_1.goBack)(), cancelLabel: "\u7D9A\u3051\u308B", confirmLabel: "\u53D6\u308A\u6D88\u3059" }),
        isLoading ? (react_1.default.createElement(react_native_1.View, { style: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: '#F5FCFF88',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement(react_native_1.ActivityIndicator, { size: "large", color: '#286D84' }))) : null));
};
exports.default = CreatePostScreen;
